<template>

    <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                    <v-card class="elevation-12">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Login form</v-toolbar-title>

                        </v-toolbar>
                        <v-card-text>

                            <v-form @submit.prevent="login" id="login-form">
                                <v-text-field prepend-icon="email" name="email" :rules="emailRules" label="Username/Email" id="username" type="email" v-model="email" required></v-text-field>

                                <v-text-field prepend-icon="lock" name="password" :rules="passwordRules" label="Password" id="password" type="password" v-model="password" required></v-text-field>
                            </v-form>

                        </v-card-text>

                        <v-flex class="ma-3">
                            <v-alert
                                    :value="errorStatus"
                                    type="error"
                            >
                                {{ errorMessage }}
                            </v-alert>
                        </v-flex>


                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn type="submit" color="primary" form="login-form">Login</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>

</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "Login",
        data: () => ({
            email: '',
            password: '',
            valid: false,
            passwordRules: [
                v => !!v || 'Password is required',
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ]
        }),
        computed: {
            ...mapGetters({
                errorStatus: 'authErrorStatus',
                errorMessage: 'authErrorMessage'
            })
        },
        methods: {
            login(){
                this.$store.dispatch('getToken', {
                    email: this.email,
                    password: this.password
                })
                    .then(response => {
                        this.$router.push({ name: 'home'})
                    })
            }
        }
    }
</script>

<style scoped>

</style>